import { AbstractControl, ValidationErrors } from '@angular/forms';

export function collegeNameValidator(control: AbstractControl): ValidationErrors | null {
	const value = control.value;
	if (!value) return null;
	const regex = /^[a-zA-Z0-9 .'-]{3,}$/;
	return regex.test(value) ? null : { invalidCollegeName: true };
}


export function degreeValidator(control: AbstractControl): ValidationErrors | null {
	const value = control.value;
	if (!value) return null;
	const regex = /^[a-zA-Z0-9 .()]{2,50}$/;
	return regex.test(value) ? null : { invalidDegree: true };
}

export function cgpaPercentageValidator(control: AbstractControl): ValidationErrors | null {
	const value = control.value;
	if (!value) return null;
	const str = value.toString().trim();
	if (str.includes('%')) {
		const num = parseFloat(str.replace('%', ''));
		if (isNaN(num)) return { invalidCgpa: true };
		const validFormat = /^[0-9]{1,3}(\.[0-9]{1,2})?%$/.test(str);
		if (!validFormat || num < 0 || num > 100) {
			return { invalidCgpa: true };
		}
		return null;
	}

const num = parseFloat(str);
	if (isNaN(num)) return { invalidCgpa: true };
	const validFormat = /^[0-9]{1,2}(\.[0-9]{1,2})?$/.test(str);
	if (!validFormat || num < 0 || num > 10) {
		return { invalidCgpa: true };
	}
	return null;
}